import { lazy, Suspense } from "react";
import { BrowserRouter, Route, Routes } from "react-router-dom";
import { WeddingPage } from "./WeddingPage";

// The admin dashboard pulls in Firebase Auth and the whole guest list; keep it
// out of the bundle every wedding guest downloads.
const AdminPage = lazy(() =>
  import("./components/admin/AdminPage").then((m) => ({ default: m.AdminPage })),
);

export function App() {
  return (
    <BrowserRouter>
      <Routes>
        <Route path="/" element={<WeddingPage />} />
        {/* Printed on the invitations; useLandingScroll jumps to the section. */}
        <Route path="/rsvp" element={<WeddingPage />} />
        <Route
          path="/admin"
          element={
            <Suspense fallback={<div className="admin"><p className="body">Loading…</p></div>}>
              <AdminPage />
            </Suspense>
          }
        />
        <Route path="*" element={<WeddingPage />} />
      </Routes>
    </BrowserRouter>
  );
}
